import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {StoryPageService_GetCategoryTreeNavigationLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/story_page/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useCategoryIdentifier} from '../../../../features/hooks/useCategoryIdentifier';
import {labelToSortingOption} from '../../../../features/ProductStream/helpers';
import {
  useAppliedPotentialFilters,
  useSorting,
} from '../../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../../shared-deprecated/useTargetGroupIdentifier';
import {useStoryIdFromUrl} from '../../utils/useStoryIdFromUrl';

export const useStoryNavigationTree = () => {
  const storyId = useStoryIdFromUrl();
  const categoryIdentifier = useCategoryIdentifier();
  const targetGroup = useTargetGroupIdentifier();
  const appliedFilters = useAppliedPotentialFilters();
  const {sorting} = useSorting();
  const fullSession = useFullSession();
  const reductionsState = useReductionsStateRequestParameter();

  return useGrpcRequest(
    StoryPageService_GetCategoryTreeNavigationLazy,
    {
      session: fullSession ?? null,
      storyId: storyId!,
      targetGroup,
      categoryId: categoryIdentifier?.identifier.id ?? null,
      appliedFilters: {
        filters: appliedFilters,
      },
      sortOptions: labelToSortingOption(sorting),
      reductionsState,
    },
    {
      disabled: !storyId,
      keepPreviousData: true,
      mockData: async params =>
        import('./__mocks__/getStoryNavigationTreeMock').then(module =>
          module.getStoryNavigationTreeMock(params),
        ),
    },
  );
};
